"use client";

import { c as _c } from "react/compiler-runtime";
import { FiPlus } from "react-icons/fi";
import { ReadOnlyCarePlan } from "@/components/care-plan/read-only-care-plan";
import { useProgressNavigation } from "@/components/progress-bar";
import { Button } from "@/components/ui";
import CollapsibleSection from "@/components/ui/collapsible-section";
import { Skeleton } from "@/components/ui/skeleton";
import { useCarePlansForPatient } from "@/hooks/use-care-plans-for-patient";
import { useModule } from "@/hooks/use-module";
import type { PatientDetail } from "@/types/patient";
interface CarePlanSectionProps {
  patient: PatientDetail;
}
export default function CarePlanSection(props) {
  const $ = _c(2);
  const hasCarePlans = useModule("CARE_PLANS");
  if (!hasCarePlans) {
    return null;
  }
  let t0;
  if ($[0] !== props) {
    t0 = <CarePlanSectionContent {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function CarePlanSectionContent(t0) {
  const $ = _c(10);
  const {
    patient
  } = t0;
  const {
    navigateWithProgress
  } = useProgressNavigation();
  const {
    data: carePlans,
    isPending
  } = useCarePlansForPatient(patient.id);
  let t1;
  if ($[0] !== navigateWithProgress || $[1] !== patient.id) {
    t1 = <Button variant="secondary" size="sm" icon={FiPlus} onClick={() => navigateWithProgress(`/patient/${patient.id}/care-plan/new`)}>Assign Care Plan</Button>;
    $[0] = navigateWithProgress;
    $[1] = patient.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== carePlans || $[4] !== isPending || $[5] !== patient.id) {
    t2 = isPending ? <div className="space-y-3"><Skeleton className="h-20 w-full" /><Skeleton className="h-20 w-full" /></div> : carePlans && carePlans.length > 0 ? <div className="space-y-4">{carePlans.map(cp => <ReadOnlyCarePlan key={cp.id} carePlan={cp} patientId={patient.id} />)}</div> : <p className="py-4 text-center text-body text-foreground-secondary">No care plans assigned yet</p>;
    $[3] = carePlans;
    $[4] = isPending;
    $[5] = patient.id;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <CollapsibleSection title="Care Plans" persistKey="care-plans" className="overflow-x-hidden" actions={t1}>{t2}</CollapsibleSection>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}